import { apiV3ShareRegistryPath } from 'lib/urls'
import fetch from 'lib/fetch'

export const shareByEmail = (values) => {
  return fetch(apiV3ShareRegistryPath(values.registryId), {
    body: JSON.stringify({ ...values }),
    method: 'POST',
  })
}
